export default __webpack_public_path__ + "static/diamond-6-7c9a8288355169c7a8ce6526d6996711.png";